/* eslint-disable max-len */
import { ActivationCodesRepository, LicensesRepository, AppIntegrationsRepository, AppPricesRepository, DevicesRepository, MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';
import offersConfiguration from '../../../abtesting/data';

const _directiveDependencies = [];
const _controllerDependencies = ['$rootScope', '$scope', '$state', '$window', 'Util', 'PaymentUrlsRestService'];

class WelcomeOfferController {

    constructor($rootScope, $scope, $state, $window, Util, PaymentUrlsRestService) {

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.Util = Util;
        this.PaymentUrlsRestService = PaymentUrlsRestService;
        this.LicensesRepository = LicensesRepository;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.endCampaignDay = Util.deepFind(CWCONFIG, 'features.offerBanner.endCampaignDay');
        this.$scope.showOPCButton = false;
        this.$scope.isOneClickPaymentEnable = CWCONFIG.features.oneClickPayment;
        $scope.showLearnMoreButton = true;
        this.$scope.language = CWCONFIG.language;
        const activationCodesRepo = ActivationCodesRepository.getAll();
        $scope.activationCodesRepoLength = activationCodesRepo.length;

        if ($scope.activationCodesRepoLength) {

            $scope.hasOnlyAia = !!(activationCodesRepo.length === 1 && activationCodesRepo.find(activationCode => activationCode.attributes.app === 'adwp1'));

        }

        // if ($rootScope.cmaGBapplies) {

        //     $scope.isFromUK = true;
        //     $scope.avProBuyUrl = 'https://www.avira.com/en/campaigns/crm/q2-fy23/f2p-antivirus-pro-mya?cookiebot_off=true';

        // }

        // const licensesRepo = LicensesRepository.getAll();
        // const user = MeRepository.getMyUser();
        // const userRegistrationDate = Util.deepFind(user, 'attributes.date_registered');
        this.runtime = 12;
        // const campaignBreakpoint =
        // Util.deepFind(CWCONFIG, 'features.offerBanner.campaignBannerDaysBreakpoint') || 120;
        // end 97% off av campaign

        this.$scope.devicesLength = DevicesRepository.getAll().length;

        this.$scope.hideBannerForThisSession = !sessionStorage.getItem('hideWOB');

        // hide welcome offer banner if user has an TP link licence
        this.$scope.hasTPLinkLicence = ActivationCodesRepository.hasTPLinkLicence();

        // filter offers if has already the license for that offer
        let filteredOffers = offersConfiguration.filter((offer) => {

            const userLicense =
            this.LicensesRepository.getLicenseByAppId(offer.productId);

            if (userLicense) {

                return offer.productId !== userLicense.relationships.app.data.id;

            }

            return true;

        });

        // AIA Banner
        const hasPrime10 = activationCodesRepo.find(activationCode => activationCode.attributes.app === 'aps10');
        const hasPrime20 = activationCodesRepo.find(activationCode => activationCode.attributes.app === 'aps20');
        const hasIsec = this.LicensesRepository.getLicenseByAppId('isec0');
        // const hasIdentityAssistant = this.LicensesRepository.getLicenseByAppId('adwp1');
        const userCountry = Util.deepFind(MeRepository.getMyUser(), 'attributes.country');
        // const isFromROW = !$rootScope.cmaGBapplies;
        // const isFromUK = $rootScope.cmaGBapplies;

        const aiaOffer = {
            product: 'Identity Assistant',
            productId: 'adwp1',
            learnMoreUrl: 'https://www.avira.com/de/avira-identity-assistant?x-a-source=cw',
            translationKeys: {
                discountDesc: userCountry === 'US' ? 'cw.dwm.offer.description' : 'cw.dwm.offer.description_row',
                learnMore: 'cw.dwm.offer.btn_learn_more',
                button: 'cw.general.buy',
            },
        };

        if ($rootScope.showAIAWelcomeOfferBanner) {

            if (hasPrime10 || hasPrime20 || hasIsec) {

                if (hasPrime20) {

                    filteredOffers = [aiaOffer];

                } else if (hasPrime10) {

                    filteredOffers[0] = aiaOffer;

                } else if (hasIsec) {

                    filteredOffers = filteredOffers.concat(aiaOffer);

                }

                const getRandomInt = max => Math.floor(Math.random() * max);
                this.currentOffer =
                    filteredOffers[getRandomInt(filteredOffers.length)];

                if (this.currentOffer.productId === 'adwp1') {

                    $scope.showIdentityAssistantBanner = true;

                } else {

                    $scope.showDefaultBanner = true;

                }

            } else if (!$scope.showAvBanner) {

                const getRandomInt = max => Math.floor(Math.random() * max);
                this.currentOffer =
                    filteredOffers[getRandomInt(filteredOffers.length)];

                if (this.currentOffer.productId === 'isec0') {

                    this.currentOffer = aiaOffer;
                    $scope.showIdentityAssistantBanner = true;

                } else {

                    $scope.showDefaultBanner = true;

                }

            }

        } else if (!$scope.showAvBanner) {

            const getRandomInt = max => Math.floor(Math.random() * max);
            this.currentOffer =
                filteredOffers[getRandomInt(filteredOffers.length)];
            $scope.showDefaultBanner = true;

        }


        //* Promotional Campaign : BF 2023 logic
        //* To be commented when the campaign is over
        // if (isFromUK) {

        //     const getRandomInt = max => Math.floor(Math.random() * max);
        //     this.currentOffer =
        //         filteredOffers[getRandomInt(filteredOffers.length)];
        //     $scope.showDefaultBanner = true;

        // } else {

        //     if (!hasPrime10 && !hasPrime20) {

        //         $scope.showPrime5Banner = true;
        //         $scope.activePromotionProduct = 'aps10_12_1';

        //         this.currentOffer = offersConfiguration.find(offer => offer.productId === 'aps10');
        //         this.currentOffer.translationKeys = {
        //             title: 'cw.offer4.campaign_description_aps10',
        //         };

        //         $rootScope.createCMAlabels(`${this.currentOffer.productId}_12_1`, this.currentOffer.product, this.currentOffer.productId, '2023-11-23', '2023-12-03');

        //     }

        //     if (activationCodesRepo.length > 0 && hasPrime10 && !hasPrime20) {

        //         $scope.showPrime25Banner = true;
        //         $scope.activePromotionProduct = 'aps20_12_1';

        //         this.currentOffer = {
        //             product: 'Avira Prime 25',
        //             productId: 'aps20',
        //             translationKeys: {
        //                 title: 'cw.offer4.campaign_description_aps20',
        //             },
        //         };

        //         $rootScope.createCMAlabels(`${this.currentOffer.productId}_12_1`, this.currentOffer.product, this.currentOffer.productId, '2023-11-23', '2023-12-03');

        //     }
        //     if ($rootScope.showAIAWelcomeOfferBanner && !hasIdentityAssistant && hasPrime20) {

        //         this.currentOffer = aiaOffer;
        //         $scope.showIdentityAssistantBanner = true;

        //     }

        // }

        // we listen to event when OCP is available in order to show OCP button
        eventManager.subscribe('showRecommendation:true', () => {

            this.$scope.showOPCButton = true;

        });
        eventManager.subscribe('showRecommendation:false', () => {

            this.$scope.showOPCButton = false;

        });

        // If user have trial prime license we show Prime offer
        const primeLicense = this.LicensesRepository.getLicenseByAppId('aps10') || this.LicensesRepository.getLicenseByAppId('aps20');
        if (primeLicense && primeLicense.attributes.type === 'eval') {

            if ($scope.showIdentityAssistantBanner) {

                this.currentOffer = aiaOffer;

            } else {

                this.currentOffer = offersConfiguration.find(offer => offer.productId === 'aps10');

            }

        }

        const pageUrl = this.$state.current.url || ' Undefined';
        this.$scope.pageName = pageUrl.substr(1);

        // Check if we still have some offer
        if (this.currentOffer) {

            // hide the learn more button redirect to comparison modal
            // for app recommendations without comparison features
            const currentUserAppId = Util.deepFind(activationCodesRepo[0], 'attributes.app');
            const recommendedApp = AppIntegrationsRepository.getById(currentUserAppId) || {};

            if (!Util.deepFind(recommendedApp, 'attributes.resource.comparisonFeatures')) {

                $scope.showLearnMoreButton = false;

            }

            // get discount from flexible promotion
            const currentAppPrices =
                AppPricesRepository.getSinglePrice(this.currentOffer.productId, 12, 1);

            this.$scope.price = this.Util.deepFind(currentAppPrices, 'attributes.promotion.price');
            const discount = this.Util.deepFind(currentAppPrices, 'attributes.promotion.discount');

            this.$scope.discount = discount ? `${discount}%` : '20%';

            // lang fix for discount
            if (CWCONFIG.language === 'de') {

                this.$scope.discount = discount ? `${discount} %` : '20 %';

            }
            if (CWCONFIG.language === 'tr') {

                this.$scope.discount = discount ? `%${discount}` : '%20';

            }


            // hide banner for this bundleIds if available in the users subscriptions
            const bundleIds = Util.deepFind(this.currentOffer, 'bundleIds') || [];

            this.$scope.voucher = Util.deepFind(this.currentOffer, 'voucher');
            this.$scope.isOfferActive = Util.deepFind(CWCONFIG, 'features.offerBanner.showOffer');
            // hide the close button if current page is subscriptions
            this.$scope.hideInSubscription = $state.current.name !== 'root.dashboard.subscriptions';
            this.$scope.hasOfferSubscriptions = false;
            this.$scope.translationKeys = this.currentOffer.translationKeys;

            if (this.currentOffer.productId === 'aapd5') {

                const appIntegration =
                    AppIntegrationsRepository.getById(this.currentOffer.productId);
                this.$scope.product = Util.deepFind(appIntegration, 'attributes.resource.name');

            } else {

                this.$scope.brandName = CWCONFIG.partnerConfig.name;
                this.$scope.product =
                    AppIntegrationsRepository.getAppName(this.currentOffer.productId);

            }

            // get offer local storage name from config
            this.offerLocalStorageName = Util.deepFind(CWCONFIG, 'features.offerBanner.localStorageName');

            // check if the offer was closed
            this.$scope.welcomeOfferWasClosed = localStorage.getItem(this.offerLocalStorageName);

            const isecComponents =
                ['aapd0', 'aapd5', 'aasc0', 'pasm1', 'mspi3', 'swoe0'];

            $scope.hasIsecComponents = false;

            // check if has Avira Prime or isec components
            activationCodesRepo.forEach((activationCode) => {

                bundleIds.forEach((primeId) => {

                    if (activationCode.attributes.app === primeId) {

                        this.$scope.hasOfferSubscriptions = true;

                    }

                });

                isecComponents.forEach((component) => {

                    if (activationCode.attributes.app === component) {

                        $scope.hasIsecComponents = true;

                    }

                });

            });

            this.$scope.hasAps10 = activationCodesRepo.find(activationCode => activationCode.attributes.app === 'aps10');
            this.$scope.hasAps20 = activationCodesRepo.find(activationCode => activationCode.attributes.app === 'aps20');
            this.$scope.primeIntegration = AppIntegrationsRepository.getById('aps10');

            // Code for Prime 25 banner
            if (this.$scope.hasAps10 && this.$scope.devicesLength > 3 && !$rootScope.showAIAWelcomeOfferBanner) {

                this.currentOffer = {
                    product: 'Avira Prime 25',
                    productId: 'aps20',
                    translationKeys: {
                        title: 'cw.banner.prime_25.title',
                        description: 'cw.banner.prime_25.description',
                        button: 'cw.banner.prime_25.button',
                    },
                };

                this.$scope.showUpsellPrime25 = true;
                this.$scope.translationKeys = this.currentOffer.translationKeys;

            }
            // Code for Prime 25 banner

            // Norton Life Lock Banner
            // if (($rootScope.requestCountry === 'US' && this.$scope.language === 'en') &&
            //     ((this.$scope.hasAps10 && this.$scope.devicesLength <= 3)
            //     || this.$scope.hasAps20)) {

            //     this.variant = 'Identity Theft Protection';
            //     this.$scope.showNortonLifeLockUpsell = true;

            //     // get offer local storage name from config
            //     this.offerLocalStorageName =
            // Util.deepFind(CWCONFIG, 'features.offerBannerNortonLifeLock.localStorageName');
            //     this.$scope.welcomeOfferWasClosed =
            //         localStorage.getItem(this.offerLocalStorageName);

            //     Mixpanel.send('ConnectWeb Banner Offer Show',
            //         { variant: 'NLOK Identity Theft Protection' }
            //     );

            // }

            setTimeout(() => {

                if (($scope.isOfferActive && (!$scope.welcomeOfferWasClosed || !$scope.hideInSubscription) && !$scope.hasOfferSubscriptions) || ($scope.isOfferActive && $scope.showUpsellPrime25 && !$scope.welcomeOfferWasClosed)) {

                    const currentAppPrice = AppPricesRepository.getSinglePrice(this.currentOffer.productId, '12', '1');
                    let finalPrice = '';
                    if (currentAppPrice) {

                        finalPrice = this.Util.deepFind(currentAppPrice, 'attributes.promotion.total_price_string');

                    }

                    Mixpanel.send('ConnectWeb Banner Offer Show', {
                        Page: this.Util.getPageName(),
                        Price: finalPrice,
                        Product: this.currentOffer.product,
                        ProductId: this.currentOffer.productId,
                    });

                }

            }, 100);

        }

        let price = '';
        let discount = '';
        if (this.currentOffer) {

            const currentPrice = AppPricesRepository.getSinglePrice(this.currentOffer.productId, '12', '1');

            if (currentPrice) {

                if (this.Util.deepFind(currentPrice, 'attributes.promotion')) {

                    price = this.Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                    discount = this.Util.deepFind(currentPrice, 'attributes.promotion.discount');

                } else {

                    price = this.Util.deepFind(currentPrice, 'attributes.price_string');
                    discount = 0;

                }

            }

        }

        this.mixpanelPayload = {
            Product: this.currentOffer ? this.currentOffer.product : '',
            ProductId: this.currentOffer ? this.currentOffer.productId : '',
            Page: this.Util.getPageName(),
            FallbackShopUrl: false,
            Price: price,
            Discount: discount,
            Runtimes: this.runtime,
        };

        if ((!this.$scope.hasTPLinkLicence && this.$scope.isOfferActive && (!this.$scope.welcomeOfferWasClosed || !this.$scope.hideInSubscription) && !this.$scope.hasOfferSubscriptions) ||
            (this.$scope.isOfferActive && this.$scope.showUpsellPrime25 && !this.$scope.welcomeOfferWasClosed)) {

            this.$rootScope.showCmaDisclaimer.banner = true;

        }

        if (this.$scope.welcomeOfferWasClosed === 'closed') {

            this.$rootScope.showCmaDisclaimer.banner = false;

            if (!this.$scope.hideInSubscription) {

                this.$rootScope.showCmaDisclaimer.banner = true;

            }

        }

        //* Promotional Campaign: $rootScope.welcomeOffer.campaign variable is used to show the campaing line in bottom discalimer
        //* To be commented when the campaign is over
        // $scope.$on('$destroy', () => {

        //     $rootScope.welcomeOffers = {};

        // });

    }

    close() {

        // set data on local storage when the offer is closed
        localStorage.setItem(this.offerLocalStorageName, 'closed');

        // update view
        this.$scope.welcomeOfferWasClosed = localStorage.getItem(this.offerLocalStorageName);
        this.$rootScope.showCmaDisclaimer.banner = false;
        Mixpanel.send('ConnectWeb Banner Offer Close');

    }

    sendMixpanelLearnMore() {

        Mixpanel.send('ConnectWeb Banner Learn More Click', {
            ProductId: this.currentOffer.productId,
        });

    }

    getOfferUK() {

        Mixpanel.send('ConnectWeb Banner Offer Click', this.mixpanelPayload);

    }

    getOffer() {

        Mixpanel.send('ConnectWeb Banner Offer Click', this.mixpanelPayload);

        this.$state.go(`${this.$state.current.name}.ltb.banner`, {
            ltb: 'payment-cart',
            resourceId: this.currentOffer.productId,
            subsource: 'banner',
            promotion: true,
            runtime: this.runtime,
        }, {
            reload: false,
        });

    }

    nortonLifeLockUpsell() {

        Mixpanel.send('ConnectWeb Banner Offer Click', this.mixpanelPayload);

    }

    learnMore() {

        const activationCodesRepo = ActivationCodesRepository.getAll();
        if (activationCodesRepo.length === 1 && this.$scope.showLearnMoreButton) {

            let stateName = this.$state.current.name;

            if (stateName.indexOf('.ltb') === -1) {

                stateName += '.ltb';

            }
            // open OCP modal
            this.$state.go(stateName, {
                ltb: 'ocp-comparison',
                resourceId: this.currentOffer.productId,
            }, {
                reload: false,
            });

        } else {

            let learnMoreUrl = this.Util.deepFind(this.currentOffer, 'learnMoreUrl');
            learnMoreUrl = learnMoreUrl.replace('{language}', CWCONFIG.language);

            if ((CWCONFIG.language === 'en' || CWCONFIG.language === 'de') &&
                this.currentOffer.productId === 'isec0') {

                /*  the new ISEC page from website doesn't contain '-suite' section in URL
                    for EN and DE languages */
                learnMoreUrl = learnMoreUrl.replace('-suite', '');
                this.$window.open(learnMoreUrl, '_blank');

            } else {

                this.$window.open(learnMoreUrl, '_blank');

            }

        }

    }

    redirectToUpsellPage() {

        this.$rootScope.redirectFromTab = 'dwm';

        this.$state.go('root.dashboard.dwm', {
            tab: 'store',
        });

    }

}


class WelcomeOfferDirective {

    constructor() {

        this.template = require('./welcome-offer.html');
        this.restrict = 'E';
        this.replace = true;

        _controllerDependencies.push((
            $rootScope, $scope, $state, $window,
            Util, PaymentUrlsRestService,
        ) =>
            new WelcomeOfferController(
                $rootScope, $scope, $state, $window,
                Util, PaymentUrlsRestService,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'welcomeOfferCtrl';

    }

}

_directiveDependencies.push(() => new WelcomeOfferDirective());

angular.module('directives')
    .directive('welcomeOffer', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/welcome-offer/welcome-offer.js